import { useMutation, UseMutationResult } from '@tanstack/react-query';

import updateOnlineStatus, {
  OnlineStatusResponse,
} from '@/actions/user/updateOnlineStatus';
import { ApiResponse } from '@/types/response.type';

export interface UseUpdateOnlineStatusProps {
  mutate: () => void;
  mutateAsync: () => Promise<ApiResponse<OnlineStatusResponse>>;
  error: Error | null;
  isError: boolean;
  isSuccess: boolean;
  isPending: boolean;
  reset: () => void;
}

export const useUpdateOnlineStatus = (): UseUpdateOnlineStatusProps => {
  const mutation: UseMutationResult<
    ApiResponse<OnlineStatusResponse>,
    Error,
    void
  > = useMutation({
    mutationFn: updateOnlineStatus,
    onSuccess: () => {
      // Optional: Log success or handle side effects
      console.log('Online status updated successfully');
    },
    onError: (error) => {
      // Optional: Log error or handle side effects
      console.error('Failed to update online status:', error);
    },
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    reset: mutation.reset,
  };
};
